import { render } from "./ReferenceRegistry.vue?vue&type=template&id=e7e69cee&scoped=true&ts=true"
import script from "./ReferenceRegistry.vue?vue&type=script&lang=ts"
export * from "./ReferenceRegistry.vue?vue&type=script&lang=ts"

import "./ReferenceRegistry.vue?vue&type=style&index=0&id=e7e69cee&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7e69cee"]])

export default __exports__